import React, { useState, useEffect, useRef } from "react";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import Typography from "@material-ui/core/Typography";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import { timeConfig, dateConfig, SET_EMPTY } from "config";
import { getContractorPunchesReportData, date, time } from "utils/report";
import { OTHER_TEAM } from "config/CONSTANTS";
import ReportHeader from "./ReportHeader";
import {
  createMuiTheme,
  makeStyles,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import {
  INCOMPLETE_BG_INVALID,
  INCOMPLETE_BG_VALID,
} from "config";
import { Card } from "@material-ui/core";
import { properCase } from "utils";
import { useDispatch } from "react-redux";
import {
  saveReportViewFilterList,
} from "redux/actions/appActions";
import {
  defaultPaginationOptions,
  getTextLabels,
} from "../../../config/index";
import { udpatePunchStatus } from "utils/activity";
import { endOfWeek, startOfWeek } from "date-fns";
import { optionsAvailable } from "pages/AddWorker/components/utils";

export const ContractorTimesheetReports = (props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState();
  const [loadingError, setLoadingError] = useState(SET_EMPTY);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const { reportViewFiltersData } = useSelector((state) => state.appConfig);
  
  //console.log("------reportViewFiltersData-------",reportViewFiltersData);
  const { user, isLoading: userLoading } = useSelector(
    (state) => state.user.auth
  );
  const blank = properCase(t("pgReview.tableStaticText.blank"));
  const [startDate, setStartDate] = useState(startOfWeek(new Date()));
  const [month, setMonth] = useState(new Date());
  const [view, setView] = useState(optionsAvailable[0]);
  const {approveForManager,selectedTeam, imtRole} = props;
  const reportTheme = createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: 6,
        },
      },
      MuiIconButton: {
        root: {
          primary: {
            color: "#1B75BC",
          },
          "&&:hover": {
            color: "#1B75BC",
          },
        },
      },
      MuiInputLabel: {
        root: {
          "&$focused": {
            color: "#1B75BC",
          },
        },
      },
      MuiCheckbox: {
        colorPrimary: {
          MuiChecked: {
            "&$checked": {
              color: "#1B75BC",
            },
          },
        },
      },
      MuiButton: {
        textPrimary: {
          color: "#1B75BC",
        },
        "&&:hover": {
          color: "#1B75BC",
        },
      },
      MuiInput: {
        underline: {
          "&&:after": {
            borderBottom: "2px solid #1B75BC",
          },
        },
      },
      MuiChip: {
        outlinedPrimary: {
          color: "#1B75BC",
          border: "1px solid #1B75BC",
        },
        deleteIcon: {
          color: "#1B75BC",
        },
      },
      MUIDataTableToolbar: {
        iconActive: {
          color: "#1B75BC",
        },
        icon: {
          "&&:hover": {
            color: "#1B75BC",
          },
        },
      },
      MuiTypography: {
        body2: {
          color: "#1B75BC",
        },
      },
    },
  });

  useEffect(() => {
    setIsLoading(true);
    setLoadingError(SET_EMPTY);
    if (user.workerId && !userLoading) {
      if (view === "Monthly") {
        let date = month ? month : new Date();
        date = date.setHours(0, 0, 0, 0);

        let userWorkerId = selectedTeam === OTHER_TEAM ? approveForManager.managerId : user.workerId

        getContractorPunchesReportData(
          userWorkerId,
          moment(startOfMonth(date)).format(dateConfig.format4),
          moment(endOfMonth(date)).format(dateConfig.format4)
        )
          .then((data) => {
            if (data && data.length > 0) {

              console.log("viewDetails",data);

              let filterData = [...data]

            // if(selectedTeam === OTHER_TEAM){
            //       if((imtRole && imtRole !== "" && imtRole.toLowerCase() === "Admin")
      
            //           || (!imtRole && user.isApprover)){
                        
            //             filterData = filterData.filter(item => item.worker && 
            //               item.worker.approvingManager && item.worker.approvingManager.includes(user.workerId) )
            //           }
            // }
    
              data = filterData.filter((item) => {
                return (
                  moment(item.outTS).isSameOrBefore(
                    moment(endOfMonth(date)),
                    "day"
                  ) &&
                  moment(item.outTS).isSameOrAfter(
                    moment(startOfMonth(date)),
                    "day"
                  )
                );
              });
              data = udpatePunchStatus(data);
              console.log("report data:", data);
              setData(data);
              setLoadingError(SET_EMPTY);
            } else {
              setLoadingError("pgReview.noPunchesToReport");
            }
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
            setLoadingError("pgReview.errLoadingWorkerList");
            console.error("ReportView: Err in getWorkerByMgr Response: ", err);
          });
      }
      if (view === "Weekly") {
        let date = startDate ? startDate : new Date();
        date = date.setHours(0, 0, 0, 0);
        let userWorkerId = selectedTeam === OTHER_TEAM ? approveForManager.managerId : user.workerId
        getContractorPunchesReportData(
          userWorkerId,
          moment(startOfWeek(date)).format(dateConfig.format4),
          moment(endOfWeek(date)).format(dateConfig.format4)
        )
          .then((data) => {
            if (data && data.length > 0) {

              let filterData = [...data]

              // if(selectedTeam === OTHER_TEAM){
              //       if((imtRole && imtRole !== "" && imtRole.toLowerCase() === "Admin")
        
              //           || (!imtRole && user.isApprover)) {
                          
              //             filterData = filterData.filter(item => item.worker && 
              //               item.worker.approvingManager && item.worker.approvingManager.includes(user.workerId) )
              //           }
              //         }
      
              data = filterData.filter((item) => {
                return (
                  moment(item.outTS).isSameOrBefore(
                    moment(endOfWeek(date)),
                    "day"
                  ) &&
                  moment(item.outTS).isSameOrAfter(
                    moment(startOfWeek(date)),
                    "day"
                  )
                );
              });
              data = udpatePunchStatus(data);
              console.log("report data:", data);
              setData(data);
              setLoadingError(SET_EMPTY);
            } else {
              setLoadingError("pgReview.noPunchesToReport");
            }
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
            setLoadingError("pgReview.errLoadingWorkerList");
            console.error("ReportView: Err in getWorkerByMgr Response: ", err);
          });
      }
    } else if (userLoading) {
      console.log("Continue loading google user's data from IRM DB!");
    } else {
      setIsLoading(false);
      setLoadingError("pgReview.errLoadingWorkerId");
      console.log(
        "ReportView: else in getWorkerByMgr condition: No Logged in worker details found!"
      );
    }
  }, [userLoading, month, startDate, view,approveForManager,selectedTeam]);

  const columns = [
    {
      name: "name",
      label: properCase(t("pgReview.tableHeads.name")),
      options: {
        filter: true,
        filterType: "dropdown",
        filterList: reportViewFiltersData[0].length
          ? reportViewFiltersData[0]
          : null,
      },
    },
    {
      name: "workerId",
      label: properCase(t("pgAddWorker.lblEmployeeId")),
      options: {
        filter: true,
        filterType: "dropdown",
        filterList: reportViewFiltersData[1].length
          ? reportViewFiltersData[1]
          : null,
      },
    },
    {
      name: "email",
      label: properCase(t("pgReview.tableHeads.email")),
      options: {
        filter: true,
        filterType: "dropdown",
        filterList: reportViewFiltersData[2].length
          ? reportViewFiltersData[2]
          : null,
      },
    },
    {
      name: "activityGroup",
      label: properCase(t("pgReview.tableHeads.activityGroup")),
      options: {
        filter: true,
        filterList: reportViewFiltersData[3].length
          ? reportViewFiltersData[3]
          : null,
          customBodyRender: (value) => {            
            if (value.toUpperCase() === "TRANSACTIONAL")
            {
             return properCase(t("pgHome.reportlabel2Transcational"))
            } 
            else if (value.toUpperCase() === "PROJECT"){
             return  properCase(t("pgHome.reprotlabel3Project"))
            }
            else if(value.toUpperCase() === "NON-TRANSACTIONAL"){
             return properCase(t("pgHome.reportlabel1Non-Transactional"))
            }
            else if(value.toUpperCase() === "LEAVE"){
              return properCase(t("other.lblLeave"))
             }
             else if(value.toUpperCase() === "MEAL"){
              return properCase(t("other.tlMeal"))
             }
            else if(value.toUpperCase() === "BUILDING MOVES"){
              return properCase(t("other.tlbuildingmoves"))
             }
             else {
              return value; 
            }
          },
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.buildingId")),
      name: "buildingId",
      options: {
        filter: true,
        filterList: reportViewFiltersData[4].length
          ? reportViewFiltersData[4]
          : null,
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.projectInfo")),
      name: "jobProjectInfo",
      options: {
        filter: true,
        display: true,
        viewColumns: true,
        filterList: reportViewFiltersData[5].length
          ? reportViewFiltersData[5]
          : null,
        filterOptions: {
          renderValue: (v) => (v !== SET_EMPTY ? v : blank),
        },
        customFilterListOptions: {
          render: (v) => (v !== SET_EMPTY ? v : blank),
        },
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.startDate")),
      name: "inLocalTS",
      options: {
        sort: true,
        filter: true,
        filterList: reportViewFiltersData[6].length
          ? reportViewFiltersData[6]
          : null,
        download: false,
        customBodyRender: (value) => {
          return date(value);
        },
      },
    },
    {
      // Added to include the formatted start date in the downloaded csv
      label: properCase(t("pgReview.tableHeads.startDate")),
      name: "startDate",
      options: {
        download: true,
        display: false,
        filter: false,
        viewColumns: false,
        filterList:
          reportViewFiltersData[7] && reportViewFiltersData[7].length
            ? reportViewFiltersData[7]
            : null,
        //filterList: reportViewFiltersData[11].length ? reportViewFiltersData[11] : null,
      },
    },
    {
      label: properCase(t("pgReview.tableHeads.duration")),
      name: "duration",
      options: {
        filter: false,
        filterList:
          reportViewFiltersData[8] && reportViewFiltersData[8].length
            ? reportViewFiltersData[8]
            : null,
        //filterList: reportViewFiltersData[15].length ? reportViewFiltersData[15] : null,
      },
    },
    {
      label: properCase(t("other.dayDuration")),
      name: "dayTotalDuration",
      options: {
        filter: false,
        filterList:
          reportViewFiltersData[9] && reportViewFiltersData[9].length
            ? reportViewFiltersData[9]
            : null,
        //filterList: reportViewFiltersData[15].length ? reportViewFiltersData[15] : null,
      },
    },
    {
      label: properCase(t("other.weekDuration")),
      name: "weekTotalDuration",
      options: {
        filter: false,
        filterList:
          reportViewFiltersData[10] && reportViewFiltersData[10].length
            ? reportViewFiltersData[10]
            : null,
        //filterList: reportViewFiltersData[15].length ? reportViewFiltersData[15] : null,
      },
    },
    {
      label: properCase(t("other.weekNumber")),
      name: "weekNumber",
      options: {
        filter: false,
        filterList:
          reportViewFiltersData[11] && reportViewFiltersData[11].length
            ? reportViewFiltersData[11]
            : null,
        //filterList: reportViewFiltersData[15].length ? reportViewFiltersData[15] : null,
      },      
    },
    {
      label: properCase(t("other.managerName")),
      name: "managerName",
      options: {
        filter: true,
        display:false,
        download:true,
        filterList:
          reportViewFiltersData[12] && reportViewFiltersData[12].length
            ? reportViewFiltersData[12]
            : null,
        //filterList: reportViewFiltersData[15].length ? reportViewFiltersData[15] : null,
      },   
    },
    {
      label: properCase(t("other.managerId")),
      name: "managerId",
      options: {
        filter: true,
        display:false,
        download:true,
        filterList:
          reportViewFiltersData[13] && reportViewFiltersData[13].length
            ? reportViewFiltersData[13]
            : null,
        //filterList: reportViewFiltersData[15].length ? reportViewFiltersData[15] : null,
      },   
    }
  ];

  let totalDurationRef = useRef();
  // let totalActivityRef = useRef();
  // let totalMealRef = useRef();
  let indexArray = [];
  // let mealArray = [];
  // let actArray = [];
  let Tot = 0;
  // let mealTotal = 0;
  // let actTotal = 0;
  const options = {
    filter: true,
    download: true,
    print: false,
    filterType: "multiselect",
    responsive: "standard",
    selectableRows: false,
    onFilterChange: (filterList) => {
      //console.log("---filterList----",filterList);
      //console.log("----columnChanged-----",columnChanged);
      dispatch(saveReportViewFilterList(filterList));
    },
    setFilterChipProps: (colIndex, colName, data) => {
      console.log(colIndex, colName, data);
      return {
        style: { color: "#1B75BC", border: "1px solid #1B75BC" },
        variant: "outlined",
        className: "testClass123",
      };
    },

    onTableChange: (action, tableState) => {
      indexArray = [];
      // mealArray = [];
      // actArray = [];
    },

    // apply background color to rows with incomplete status
    setRowProps: (row, dataIndex, rowIndex) => {
      const bgWithinRange = INCOMPLETE_BG_VALID;
      const bgOutOfRange = INCOMPLETE_BG_INVALID;
      if (data[dataIndex]) {
        let tempTot = parseFloat(parseFloat(data[dataIndex].duration) + Tot);
        if (!indexArray.includes(dataIndex)) {
          indexArray.push(dataIndex);
          setTotalDuration(tempTot);
        }

        const {startDate } = data[dataIndex];
        if (!(startDate)) {
          let applyColor =
            startDate &&
            moment().diff(moment(startDate, dateConfig.format3), "days") > 14
              ? bgOutOfRange
              : bgWithinRange;
          return {
            style: { backgroundColor: applyColor },
          };
        }
      }
      return {};
    },

    setTableProps: () => {
      setTotalDuration(0);
    },

    // rowsPerPage: defaultRowsPerPage,
    rowsPerPageOptions: defaultPaginationOptions,
    textLabels: getTextLabels(t),
    downloadOptions: { filename: "ContractorTimesheetReportData.csv" },
  };

  const setTotalDuration = (val) => {
    Tot = val;
    if (totalDurationRef.current) {
      totalDurationRef.current.innerText = parseFloat(Tot).toFixed(2);
    }
  };

  const classes = useStyles();
  return (
    <>
    <div style={{padding: 24}}>
    <ReportHeader 
      dateHandles={[month, setMonth]}
      weekHandles={[startDate, setStartDate]}
      optionsAvailable={optionsAvailable}
      viewHandles={[view, setView]}/>
      {
        isLoading ? (
          <>
            <CircularProgress />
            <Typography variant="body2">
              {t("pgReview.loadingGoogleUserDetails")}
            </Typography>
          </>
        ) : loadingError ? (
          <Alert severity="info">{t(loadingError)}</Alert>
        ) : null
        // reportMarkup
      }

      <div className={isLoading || loadingError ? classes.hideElem : ""}>
        <MuiThemeProvider theme={reportTheme}>
          <MUIDataTable
            title={properCase(t("pgReview.punchReport"))}
            data={data}
            columns={columns}
            options={options}
          />
          <Card className={classes.container}>
            <span className={classes.label1}>
              {properCase(t("pgReview.totalHours"))}
            </span>
            <span className={classes.label2} ref={totalDurationRef}></span>
          </Card>
        </MuiThemeProvider>
      </div>
      </div>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  hideElem: {
    display: "none",
  },
  container: {
    marginTop: 10,
    background: "#1B75BC",
    color: "white",
    fontSize: 16,
    fontWeight: "bolder",
    minHeight: 40,
    width: "100%",
    lineHeight: 3,
  },
  label1: {
    marginLeft: 80,
  },
  label2: {
    marginLeft: 30,
    width: "100%",
  },
}));

export const ts = (time) => {
  return time
    ? moment(time).format(timeConfig.format4) +
        " " +
        moment(time).format(dateConfig.format5)
    : null;
};

ContractorTimesheetReports.propTypes = {
  month: PropTypes.any.isRequired,
  week: PropTypes.any.isRequired,
  view: PropTypes.any.isRequired,
};
export default ContractorTimesheetReports;
